export class InvalidRequestError extends Error {
    constructor(body) {
        super();
        this.message = body;
        this.name = 'InvalidRequestError';
    }
}
